var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGestor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.679 14.5013H11.7779C11.664 14.5013 11.5605 14.5744 11.5242 14.6894C10.8407 16.7896 8.92472 18.1846 6.74468 18.1846C6.71879 18.1846 6.68772 18.1846 6.66183 18.1846C3.9536 18.1428 1.73213 15.8806 1.71141 13.1481C1.70106 11.7846 2.21888 10.5045 3.17168 9.53279C4.12448 8.56104 5.39315 8.02814 6.74468 8.02814H12.912C13.0621 8.02814 13.1812 7.90798 13.1812 7.75647V6.88398C13.1812 6.73247 13.0621 6.6123 12.912 6.6123H6.80164C5.08764 6.6123 3.46684 7.29149 2.22924 8.51924C0.991635 9.75222 0.313284 11.377 0.308105 13.1011C0.308105 14.8357 0.976101 16.4657 2.19299 17.6934C3.40988 18.9212 5.0255 19.6004 6.7395 19.6004C8.17388 19.6004 9.53058 19.1354 10.6646 18.2525C11.7624 17.3957 12.5702 16.1888 12.943 14.8513C12.9638 14.7677 12.9482 14.6841 12.8964 14.6162C12.8447 14.5431 12.767 14.5013 12.679 14.5013Z",
    fill: "url(#paint0_linear_910_17953)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1257 4.45982C18.8047 3.67615 18.3386 2.96562 17.7431 2.35957C16.5159 1.10047 14.8899 0.405615 13.1655 0.400391C13.1604 0.400391 13.1604 0.400391 13.1552 0.400391C10.2605 0.400391 7.70248 2.3648 6.9361 5.1808C6.91538 5.26439 6.93092 5.34798 6.9827 5.42113C7.03448 5.48904 7.11216 5.52562 7.19501 5.52562H8.1012C8.2203 5.52562 8.31869 5.45247 8.35494 5.33753C9.03329 3.22162 10.9596 1.81623 13.1552 1.81623C13.1811 1.81623 13.207 1.81623 13.2329 1.81623C16.0084 1.85802 18.2402 4.17247 18.204 6.9728C18.1677 9.74178 15.9048 11.9988 13.1604 11.9988H6.97752C6.82735 11.9988 6.70825 12.1189 6.70825 12.2704V13.1429C6.70825 13.2944 6.82735 13.4146 6.97752 13.4146H13.1604C14.864 13.4146 16.4693 12.7511 17.6862 11.539C18.903 10.3321 19.5866 8.723 19.6125 7.00937C19.6228 6.13166 19.4623 5.27484 19.1257 4.45982Z",
    fill: "url(#paint1_linear_910_17953)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_910_17953",
    x1: 5.25148,
    y1: 16.732,
    x2: 15.6266,
    y2: -8.02913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0145945,
    stopColor: "#68BAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0935566,
    stopColor: "#5FA9AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4101,
    stopColor: "#3D6A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6775,
    stopColor: "#253B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8823,
    stopColor: "#161F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10142D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_910_17953",
    x1: 8.54844,
    y1: 18.1135,
    x2: 18.9235,
    y2: -6.6476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0145945,
    stopColor: "#68BAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0935566,
    stopColor: "#5FA9AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4101,
    stopColor: "#3D6A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6775,
    stopColor: "#253B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8823,
    stopColor: "#161F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10142D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestor);
export default __webpack_public_path__ + "static/media/gestor.2b45a75c9482e240e2b7f4b49d1738be.svg";
export { ForwardRef as ReactComponent };